import isUndefined from 'lodash/isUndefined';

import { reportServerError } from 'app/server/utils/errorReporter';

const DEFAULT_ERROR = 'Something went wrong! Please try again.';

export function isApiResponseError(err) {
    return Boolean(err.response);
}

export function isApiRequestError(err) {
    return Boolean(err.request);
}

function getUsefulReqInfo(req) {
    return {
        url: req.originalUrl,
        ip: req.ip,
        referer: req.get('referer'),
        userAgent: req.get('user-agent'),
        host: req.get('host'),
        traceId: req.id,
    };
}

const errorUtils = {
    formatError: (errorData) => {
        let rawErrorsCopy = null;
        let errorCopy = {};

        if (isUndefined(errorData) ||
            isUndefined(errorData.error)
        ) {
            if (errorData && errorData.errors) {
                rawErrorsCopy = errorData.errors;
            }
            errorCopy = {
                message: DEFAULT_ERROR,
            };
        } else {
            errorCopy = errorData.error;

            // status code
            errorCopy.httpStatus = errorData.httpStatus || '';
        }

        return { errorCopy, rawErrorsCopy };
    },
    logApiRequestError(err, req) {
        return errorUtils.logToSplunk({
            error: err,
            errorStack: err.stack,
            errorMessage: err.message,
            axiosConfig: err.config,
            ...req ? getUsefulReqInfo(req) : {},
        }, err.message);
    },
    logApiResponseError(err, req) {
        return errorUtils.logToSplunk({
            error: err,
            errorStack: err.stack,
            errorMessage: err.message,
            responseStatus: err.response.status,
            responseHeaders: err.response.headers,
            ...req ? getUsefulReqInfo(req) : {},
        }, err.message);
    },
    logToSplunk(data, message) {
        if (__SERVER__) {
            global.TEMPORARY_global_logger.error(data, message);
        } else {
            // TODO: send to node api to write log
            global.TEMPORARY_global_logger.error(data, message);
        }
    },
    sendToNotificationService({
        error,
        errorLocation,
        errorClass,
        req,
    }) {
        if (__SERVER__) {
            return reportServerError({
                error,
                errorLocation,
                errorClass,
                req,
            });
        }

        return errorUtils.logToSplunk(error, 'logging client side notification service send');
    },
    handleError({
        error,
        errorClass,
        errorLocation,
        req,
    }) {
        if (isApiResponseError(error)) {
            errorUtils.logApiResponseError(error, req);
        } else if (isApiRequestError(error)) {
            errorUtils.logApiRequestError(error, req);
        } else if (req) {
            errorUtils.sendToNotificationService({
                error,
                errorLocation,
                errorClass,
                req,
            });
        } else {
            errorUtils.logToSplunk(error, 'logging general error');
        }
    },
};


export default errorUtils;
